module.exports = __webpack_public_path__ + "media/táng wan loie wan nîa.46097b83.mp3";